var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('response-button',{attrs:{"color":_vm.btnColor,"loading":_vm.loading,"disabled":_vm.disabled,"label":"common.save","icon":"done","type":"submit"},on:{"click":_vm.save}})}
var staticRenderFns = []

export { render, staticRenderFns }